// extracted by mini-css-extract-plugin
export default {"container":"DropDownMenu_container__Pq4ZY","valueText":"DropDownMenu_valueText__QgDwN","rightArrowImage":"DropDownMenu_rightArrowImage__xArbq"};